const swatchers = document.querySelectorAll('.radio__fieldset .swatch__button');
const thumbnailsClick = document.querySelectorAll("[data-slideshow-thumbnail]");

const syncSlide = (swatchers, thumbnails) => {
    swatchers.forEach((swatcher, index) => {
        swatcher.addEventListener('click', () => {
            if (index < thumbnails.length) {
                thumbnails[index].click();
            }
        });
    });
};

syncSlide(swatchers, thumbnailsClick);